import React, { useEffect } from 'react'
import Contact from '../components/ContactPage/Contact'

const ContactPage = () => {

  useEffect(() => {
          window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Contact />
    </div>
  )
}

export default ContactPage
